// extracted by mini-css-extract-plugin
module.exports = {"cronometro":"Cronometro_cronometro__3iHsq","relogioWrapper":"Cronometro_relogioWrapper__3sY7m","titulo":"Cronometro_titulo__1o8CV"};